import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7289c4c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("blockquote", null, "课程范围覆盖：前端\\服务端\\人工智能\\大数据\\移动端\\系统测试等主流技术，充分满足了职业成长、自我提升等实际需求，帮助开发者实现从技能提升到岗位提升的能力闭环。", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("pre", null, "课程紧贴前沿技术、帮助开发者快速迭代技术体系保持核心竞争力。", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("blockquote", null, "以职业发展为导向的实战课程，边学边练快速进入实操状态提升个人技能，还原企业真实开发场景接轨企业真实技能标准，帮助开发者在技术快速更迭大环境下保持核心竞争力。", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("pre", null, "项目接轨企业实际开发场景、帮助开发者快速拥有企业级实战技能。", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_typography_link = _resolveComponent("a-typography-link")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { class: "center-container" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_content, {
        class: "center-div",
        style: { background: '#fff', padding: '75px 50px 20px 50px', margin: 0, minHeight: '720px' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            hoverable: false,
            bordered: true,
            style: {"padding":"20px"},
            bodyStyle: { padding: '25px' },
            type: 'inner',
            class: "card"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_a_typography_title, { level: 3 }, {
                  default: _withCtx(() => [
                    _createTextVNode("佰特编码 "),
                    _createVNode(_component_a_typography_text, { code: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Better Coding")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_typography_paragraph, { strong: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 生命不息 编码不止！ ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_typography_paragraph, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" 我们是IT教育行业的布道者，前沿技术的探索者和传播者！ "),
                    _createVNode(_component_a_typography_text, { mark: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("『实战化』和『体系化』")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" 的课程设计，通过紧贴企业实战项目，体系化的提升开发者能力，让开发者专注于 "),
                    _createVNode(_component_a_typography_text, { strong: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("编码过程形成学习闭环提升职业技能。")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_typography_paragraph, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" 我们提供完善的设计原则、最佳实践和开发源码（ "),
                    _createVNode(_component_a_typography_text, { code: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("GitHub")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" 和 "),
                    _createVNode(_component_a_typography_text, { code: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Gitee")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" ），来帮助开发者快速设计开发出高质量的产品原型。 ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_typography_paragraph, null, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_a_typography_link, { href: "#" }, {
                          default: _withCtx(() => [
                            _createTextVNode("课程体系")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_typography_paragraph, null, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_typography_paragraph, null, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_a_typography_link, { href: "#" }, {
                          default: _withCtx(() => [
                            _createTextVNode("项目实战")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_typography_paragraph, null, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _hoisted_5
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_TheFooter, { style: {"margin-top":"0px"} })
    ]),
    _: 1
  }))
}